module.exports = __webpack_public_path__ + "files/SPIADI2026 - RÉA EXPL AUR - Guide Technique.82a80a88ed2661793d18c40db720db00.pdf";